import { useState } from 'react';
import { ANIMATION_TIMINGS } from '../constants/config';

export const useIntroAnimation = () => {
  const hasSeenIntro = sessionStorage.getItem('hasSeenIntro');
  const [introComplete, setIntroComplete] = useState(!!hasSeenIntro);
  const [skipAnimation, setSkipAnimation] = useState(!!hasSeenIntro);

  const handleIntroComplete = () => {
    setIntroComplete(true);
    setSkipAnimation(true);
    sessionStorage.setItem('hasSeenIntro', 'true');
  };

  return {
    introComplete,
    skipAnimation,
    handleIntroComplete,
    animationTimings: ANIMATION_TIMINGS
  };
};
